// extracted by mini-css-extract-plugin
module.exports = {"oglasiContent":"Oglasi_oglasiContent__2iFzL Common_widthContainer__152RV"};